<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QCthm/tc-custom/9781452112855.jpg?1737758516881" alt="This image is the cover for the book Sunday Brunch"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sunday Brunch
      </h1>
      <p class="bookDescription body article font2">
        <b>A year’s worth of recipes for Sunday socializing, from muffins to mimosas.</b><br/><br/>Betty Rosbottom, beloved author of <i>Sunday Soup</i> and <i>Sunday Roasts</i>, knows how to make Sundays feel special. For this title in her Sunday series, she turns to the most leisurely and convivial meal of the week, brunch. <br/><br/>Providing a year’s worth of special meals, this book contains eighty mouthwatering recipes for eggs, stratas, pancakes, waffles, quickbreads, hash, and beverages, as well as thirty-two tantalizing color photographs and dozens of delicious menus. Full of enduring staples and delicious surprises, <i>Sunday Brunch</i> will become the go-to for tried and true Sunday treats.<br/><br/>Try: Plum Parfaits with Yogurt and Granola * Espresso-Scented Coffee Cake * Golden Pecan Waffles with Warm Salted Caramel Sauce and Bananas * Eggs Benedict with New Orleans Accents * Spicy Shrimp and Grits * and many more
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Betty Rosbottom, Susie Cushner
      </h2>
      
      <p class="authorDescription body article">Betty Rosbottom has been a cooking teacher, columnist, and cookbook author for two decades. She lives part-time in Amherst, Massachusetts, and Paris, France.Susie Cushner is a food and lifestyle photographer based in New York.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c12b30a